import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink(WA_MESSAGES.float)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-btn"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.94 }}
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#25D366] shadow-[0_10px_40px_rgba(37,211,102,0.35)] hover:shadow-[0_10px_50px_rgba(37,211,102,0.55)] transition-shadow duration-300"
    aria-label="Fale conosco pelo WhatsApp"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
    <span className="relative flex items-center justify-center w-14 h-14">
      <MessageCircle className="w-6 h-6 text-white" fill="white" />
    </span>
    <span className="relative max-w-0 overflow-hidden group-hover:max-w-[220px] transition-all duration-500 ease-out">
      <span className="block whitespace-nowrap text-white text-sm font-semibold pr-5">
        Atendimento confidencial
      </span>
    </span>
  </motion.a>
);
